import type { HelpFile } from '../../types/help'
import { OutboundConnectorsTestIds } from '../../../testids/OutboundConnectorsTestIds'

export const outboundConnectorsHelp: HelpFile = {
  docPage: '/docs/systems/connectors',
  texts: {
    [OutboundConnectorsTestIds.outboundConnectorsList]: 'Konnektoren, die Zielsysteme mit der IAM-Plattform für automatisierte Kontobereitstellung und Synchronisierung verbinden.',
    [OutboundConnectorsTestIds.colSystem]: 'Zielsystem, mit dem dieser Konnektor verbunden ist.',
    [OutboundConnectorsTestIds.colType]: 'Konnektor-Protokoll — SCIM, REST, LDAP oder Datenbank.',
    [OutboundConnectorsTestIds.colStatus]: 'Aktiviert oder Deaktiviert — deaktivierte Konnektoren führen keine Bereitstellungsaufgaben aus.',
    [OutboundConnectorsTestIds.colLastUpdated]: null,
    [OutboundConnectorsTestIds.connectorsTable]: null,
    [OutboundConnectorsTestIds.connectorsSkeleton]: null,
    [OutboundConnectorsTestIds.connectorTypeSelect]: 'Nach Konnektor-Protokolltyp filtern.',
    [OutboundConnectorsTestIds.createConnectorButton]: null,
  },
}
